function timeMinutes(value) {
  if (typeof value !== "string" || !/^(?:[01]\d|2[0-3]):[0-5]\d$|^24:00$/.test(value)) return null
  const [hours, minutes] = value.split(":").map(Number)
  return hours * 60 + minutes
}

function scheduleSummary(times) {
  if (!Array.isArray(times) || !times.length) return null
  const blocks = times.map((block) => ({
    start: timeMinutes(block?.start),
    end: timeMinutes(block?.end),
    type: String(block?.type || "Arbeitszeit").trim().toLowerCase(),
  }))
  if (blocks.some((block) => block.start === null || block.end === null || block.start >= block.end || !["arbeitszeit", "pause"].includes(block.type))) {
    return null
  }
  blocks.sort((left, right) => left.start - right.start)

  const periods = []
  const pauseStarts = []
  let previous = null
  for (const block of blocks) {
    if (previous && block.start < previous.end) return null
    if (!previous || block.start > previous.end) {
      // Keep the boundaries of split shifts too; moving an unpaid gap is not a pause move.
      if (block.type === "pause" || previous?.type === "pause") return null
      periods.push({ start: block.start, end: block.end, workMinutes: 0, pauseDurations: [] })
    }
    const period = periods[periods.length - 1]
    period.end = block.end
    if (block.type === "pause") {
      if (previous?.type === "pause") return null
      period.pauseDurations.push(block.end - block.start)
      pauseStarts.push(block.start)
    } else {
      period.workMinutes += block.end - block.start
    }
    previous = block
  }
  if (previous.type === "pause" || !pauseStarts.length) return null
  return { periods, pauseStarts }
}

// This is a display filter only. Keep uncertain entries and every additional change visible.
export function isBreakOnlyShiftChange(entry) {
  if (entry?.applicationStatus && entry.applicationStatus !== "applied") return false
  if (!Array.isArray(entry?.changes) || entry.changes.length !== 1 || entry.changes[0]?.field !== "times") return false

  const before = scheduleSummary(entry.changes[0].before)
  const after = scheduleSummary(entry.changes[0].after)
  if (!before || !after) return false
  return JSON.stringify(before.periods) === JSON.stringify(after.periods) && JSON.stringify(before.pauseStarts) !== JSON.stringify(after.pauseStarts)
}
